import { render, staticRenderFns } from "./ConsultResponseV2List.vue?vue&type=template&id=a7167536&"
import script from "./ConsultResponseV2List.vue?vue&type=script&lang=ts&"
export * from "./ConsultResponseV2List.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports